import clsx from "clsx";
import React from "react";

type XSButtonProps = {
  children: React.ReactNode | string;
  variant: "default" | "text";
  onClick?: () => void;
};

const XSButton: React.FC<XSButtonProps> = (props) => {
  const { children, variant, onClick } = props;

  return (
    <div
      className={clsx(
        "flex h-6 w-6 cursor-pointer items-center justify-center rounded-full",
        [
          variant === "default" && "bg-lightPrimary",
          variant === "text" && "bg-transparent",
        ]
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default XSButton;
